import { Helmet } from "react-helmet-async";
import { ASSETS } from "@/data/site";

const DEFAULT_DESCRIPTION =
  "Glasgow Riding for the Disabled Association (RDA Glasgow) — equine therapy for disabled people across Greater Glasgow. Scottish Charity SC002041.";

export const Seo = ({ title, description = DEFAULT_DESCRIPTION, image = ASSETS.heroMain, path }) => {
  const origin =
    typeof window !== "undefined" ? window.location.origin : "https://rdaglasgow.org";
  const currentPath =
    path || (typeof window !== "undefined" ? window.location.pathname : "/");
  const url = origin + currentPath;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="RDA Glasgow" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};
